import _ from 'lodash';
import React, { PureComponent } from "react";
import { Modal, ModalBody, ModalFooter } from "reactstrap";
import IconPainel from "../../images/icon-tv-WHITE.svg";
import { estabelecimentoService } from "../../_services/estabelecimento.service";
import FormSelectInput from "../inputs/FormSelectInput";
import InputViewEdit from "../inputs/InputViewEdit";
import DOMPurify from 'dompurify';



const modifiers = {
  preventOverflow: {
    enabled: false
  },
  flip: {
    enabled: false
  }
};

export class ModalViewModeloProntuario extends PureComponent<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,

    };
  }

  cancelar = () => {
    this.props.toogle();
  };


  concatenaModelo = () => {
    const {
      modeloVisualizacao,
    } = this.props;
    this.props.concatenaModelo(modeloVisualizacao);
  }

  substituirModelo = () => {
    const {
      modeloVisualizacao,
    } = this.props;
    this.props.setFieldValue(modeloVisualizacao);
    this.props.toogle();
  }
  render() {
    const {
      modeloVisualizacao,
    } = this.props;
    return (
      <React.Fragment>
        <Modal
          isOpen={this.props.isOpen}
          toggle={this.props.toggle}
          backdrop="static"
          modalClassName=""
          className="modal-termo modal-xl"
          centered={true}
          modifiers={modifiers}
          target={this.props.target}
        >
          <ModalBody>
            <div className="row top-modal">
              <div className="col-12 text-center my-2">
                <h2 className="font-weight-bold">{this.props.tituloModal}</h2>
              </div>
            </div>
            <div
              className="col-12 text-left mb-2"
              dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(_.get(modeloVisualizacao, 'anamnese', _.get(modeloVisualizacao, 'prescricao', ''))) }}
            />
          </ModalBody>
          <ModalFooter>
            <React.Fragment>
              <div className="w-100 text-center">
                <button
                  className="btn btn-primary"
                  type="button"
                  onClick={() => {
                    this.concatenaModelo();
                  }}
                >
                  Adicionar este modelo à anamnese
                </button>
                <button
                  className="btn btn-blue"
                  type="button"
                  onClick={() => {
                    this.substituirModelo();
                  }}
                >
                  Substituir anamnese com este modelo
                </button>

                <button
                  className="btn btn-danger"
                  type="button"
                  onClick={() => {
                    this.cancelar();
                  }}
                >
                  Cancelar
                </button>


              </div>

            </React.Fragment>
          </ModalFooter>
        </Modal>
      </React.Fragment>
    );
  }
}
